import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import type { PDFDocumentLoadingTask } from 'pdfjs-dist';

@Injectable({ providedIn: 'root' })
export class PdfTextLoaderService {
  private readonly document = inject(DOCUMENT);

  async open(data: ArrayBuffer): Promise<PDFDocumentLoadingTask> {
    const pdfjs = await import('pdfjs-dist');

    pdfjs.GlobalWorkerOptions.workerSrc = new URL('assets/pdfjs/pdf.worker.mjs', this.document.baseURI).href;

    return pdfjs.getDocument({ data: new Uint8Array(data.slice(0)) });
  }
}
